import serverCall from "../../serverCall";

const getConversationType = (type) => {
  try {
    const response = serverCall.post(
      `/company/create-conversation?conversationType=${type}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createChat = (
  selectedConversationType,
  companyId,
  companyName,
  userQuestion
) => {
  try {
    const response = serverCall.post(
      `/company/chat?conversationId=${selectedConversationType}&companyId=${companyId}&category=${companyName}&question=${userQuestion}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getAllChats = () => {
  try {
    const response = serverCall.get(`/company/get-conversation`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getSingleChat = (companyId, conversationId) => {
  try {
    const response = serverCall.get(
      `/company/get-chat-history?companyId=${companyId}&conversationId=${conversationId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createOrganization = (body) => {
  try {
    const response = serverCall.post(`/company/create-organization`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteFile = (companyId, documentURL) => {
  try {
    const response = serverCall.delete(
      `/company/delete-document?companyId=${companyId}&documentURL=${documentURL}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteindividualfile = (adminId, documentURL) => {
  try {
    const response = serverCall.delete( 
      `/company/delete-individual-doc?adminId=${adminId}&documentURL=${documentURL}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const ChatService = {
  getConversationType,
  createChat,
  getAllChats,
  getSingleChat,
  createOrganization,
  deleteFile,
  deleteindividualfile
};

export default ChatService;
